<script>
	import { getNewIcon } from "../../card_images";
	import OperationRestriction from './OperationRestriction.svelte';
	import OperationText from './OperationText.svelte';
	import "../shared.css";

	export let operations;
	export let labelColor;
	export let textColor = 'inherit';
</script>

{#each operations as op}
	<div class="op">
		<span class="op-text">
			{#if op.isExplicitNonOp}
				<div class="non-op font-heading">{op.text.toUpperCase()}</div>
			{:else}
				{#if op.isAction}
					<span class="op-action"><img class="op-action" src={getNewIcon('action')} /></span>
				{:else if op.droneAction}
					<span class="op-action">
						{#each { length: op.droneAction } as _}
							<img src={getNewIcon('drone')} />
						{/each}
					</span>
				{/if}
				{#if op.isAttack}
					<span class="op-type font-heading" style="--c:red">ATTACK</span>
				{/if}
				{#if op.type === 'surprise'}
					<span class="surprise-type">
						<span class="op-type font-heading margin-r" style="--c:{labelColor}"
							>{op.type.toUpperCase()}</span
						>
						<span class="bot-only font-body">(Bot only)</span>
						<span class="op-type font-heading margin-r" style="--c:{labelColor}">:</span>
					</span>
				{:else if op.type}
					<span class="op-type font-heading margin-r" style="--c:{labelColor}"
						>{op.type.toUpperCase()}:</span
					>
				{:else}
					<span>error</span>
				{/if}
				{#if op.restriction}
					<OperationRestriction {textColor} restriction={op.restriction} />
				{/if}
				<OperationText text={op.text} color={textColor} />
			{/if}
		</span>
	</div>
{/each}

<style lang="scss">
	.op {
		padding: calc(var(--height) / 401) calc(var(--height) / 133.67) calc(var(--height) / 401) 0;//1px 4px 1px 0px;
		user-select: none;
		flex-direction: row;
		&:first-of-type {
			padding-top: calc(var(--height) / 133.667); //3px;
		}
		&:last-of-type {
			padding-bottom: calc(var(--height) / 133.667); //3px;
		}
		& > .op-text {
			margin-left: calc(var(--width) / 95.6667); //3px;
			line-height: 1.1;
		}
	}
	.op-action > :global(img) {
		flex-shrink: 0;
		margin-left: calc(var(--height) / 200.5); //2px;
		margin-right: calc(0px - var(--height) / 401); //-1px;
		margin-bottom: calc(0px - var(--height) / 200.5); //-2px;
		width: calc(var(--width) / 20.5); //14px;
	}
	.op-type {
		font-weight: bold;
		font-size: 0.9em;
		color: var(--c);
		margin-right: calc(0px - var(--height) / 401); //-1px;
	}
	.surprise-type {
		display: inline-flex;
		align-items: baseline;
	}
	.bot-only {
		font-size: 0.9em;
		margin-left: calc(var(--height) / 200.5); //2px;
	}
	.non-op {
		color: rgb(155, 7, 7);
		text-shadow:
			-1px -1px 0 #fff,
			1px -1px 0 #fff,
			-1px 1px 0 #fff,
			1px 1px 0 #fff;
		font-weight: bold;
		font-size: calc(var(--height) / 26.73333); //15px;
		line-height: 1;
		padding-bottom: calc(var(--height) / 200.5); //2px;
	}
</style>
